// ForgotPasswordModal.js
import React, { useState } from "react";
import "../css/forgotPasswordModal.css";

const ForgotPasswordModal = ({
  isOpen,
  onClose,
  onSubmit,
  isForgotDisabled,
}) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(email); // Pass email back to the parent component
  };

  if (!isOpen) return null; // Don't render if the modal is closed

  return (
    <div className="general modal-overlay">
      <div className="modal-content">
        {/* Close button (cross) at the top-right corner */}
        <button className="close-icon" onClick={onClose}>
          ×
        </button>
        <h2>Reset Password</h2>
        <p>Enter your email ID to receive OTP.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className="submit-btn forgot-pass-btn"
            disabled={isForgotDisabled}
          >
            {isForgotDisabled ? "Please wait..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
